import { QueryClient } from '@tanstack/vue-query';

/**
 * The app's ONE TanStack cache, created here rather than inside VueQueryPlugin so
 * that code outside a component can reach it.
 *
 * It exists because signing out has to empty it. `VueQueryPlugin` builds a client
 * for you when you do not pass one, and keeps it to itself — which left the cache
 * with no owner and no way to clear it. See `authStore.logout`.
 */
export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A table left open in a background tab should not re-run every list query
      // the moment the window is focused again.
      refetchOnWindowFocus: false,
    },
  },
});
